import { render, staticRenderFns } from "./Audio_release.vue?vue&type=template&id=65958702&style=true"
import script from "./Audio_release.vue?vue&type=script&lang=js"
export * from "./Audio_release.vue?vue&type=script&lang=js"
import style0 from "./Audio_release.vue?vue&type=style&index=0&id=65958702&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports